/* eslint-disable react/prop-types */
/* eslint-disable no-await-in-loop */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useEffect, useRef, useState } from 'react';
import {
  AutoComplete,
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  message,
  Popover,
  Row,
  Select,
  Spin,
  Table,
  Tooltip,
} from 'antd';
import moment from 'moment';

import {
  FileExcelOutlined,
  FilterOutlined,
  LoadingOutlined,
  SearchOutlined,
  SettingOutlined,
  UploadOutlined,
} from '@ant-design/icons';

import Utils from '../../Assets/Scripts/Utils';
import ModalUploadExcel from '../../Components/Instructor/ModalUploadExcel';
import {
  readLoggedRoleId,
  readPortalResource,
} from '../../Components/ResourceFieldLayout/shouldRenderTaskField';
import TaskCommentFunctions from '../../Components/Schedule/TaskCommentFunctions';
import useReportCooldown from '../../Hooks/useReportCooldown';
import useSignalR from '../../Hooks/useSignalR';
import { api } from '../../Services/axiosService';
import { exportTaskListReportByEmail } from '../../Services/exportReportService';
import {
  emptyFieldLayout,
  loadAgendaFieldLayout,
} from '../Role/FieldCustomization/API/FieldCustomizationApi';
import UserFunctions from '../User/Register/UserFunctions';

import {
  addTaskListTableFilter,
  fetchDrivers,
  fetchInstructors,
  fetchInvoiceIssuers,
  fetchReasons,
  fetchSettings,
  fetchStages,
  fetchTaskColumnsSettings,
  fetchTaskListTableFilter,
  fetchTasks,
  fetchTrainingCenters,
  fetchTrainings,
  fetchTransportCompanies,
  fetchVehicles,
  mountProductName,
  updateTask,
  updateTaskListTableFilter,
  updateTrainingListOpenFields,
} from './API/TaskListApi';
import ActionButtonsComponent from './Components/ActionButtonsComponent';
import AttachFilesModal from './Components/AttachFilesModal';
import ColumnsSettingsModal from './Components/ColumnsSettingsModal';
import ConfirmationModal from './Components/ConfirmationModal';
import DeletingModal from './Components/DeletionModal';
import EditableCellComponent from './Components/EditableCellComponent';
import ExportTaskListEmailModal from './Components/ExportTaskListEmailModal';
import LocationOnMapModal from './Components/LocationOnMapModal';
import TaskListColumns from './Shared/TaskListColumns';
import {
  applyDedicatedTaskListFilters,
  buildDealClientCnpjColumnOptions,
  buildDealClientColumnOptions,
  mapEditedRows,
  mapSubmitData,
} from './Shared/TaskListFunctions';

import './TaskListStyle.scss';

const { RangePicker } = DatePicker;

function EditableRowWrapper({ form, record, editingIds, taskList, children, ...props }) {
  const isEditing = record && editingIds.includes(record.id);

  if (isEditing && record && record.tablePageIndex !== undefined) {
    return (
      <tr {...props}>
        <Form.Item name={[record.tablePageIndex, 'id']} initialValue={record.id} hidden noStyle>
          <Input type="hidden" />
        </Form.Item>
        {children}
      </tr>
    );
  }
  return <tr {...props}>{children}</tr>;
}

export default function TaskListView() {
  const [formFilter] = Form.useForm();
  const [formTaskList] = Form.useForm();

  // Geral
  const [isLoading, setIsLoading] = useState(false);
  const [isFilterLoading, setIsFilterLoading] = useState(false);
  const [fieldsPermissions, setFieldsPermissions] = useState();
  const [taskList, setTaskList] = useState([]);
  const taskListRef = useRef([]);
  const openFieldQueueRef = useRef(Promise.resolve());
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [filters, setfilters] = useState({});
  const [columnsSettings, setColumnsSettings] = useState([]);
  const [fieldLayout, setFieldLayout] = useState(emptyFieldLayout);
  const [settings, setSettings] = useState();

  // Modal
  const [isModalDeletingVisible, setIsModalDeletingVisible] = useState(false);
  const [isModalConfirmationVisible, setIsModalConfirmationVisible] = useState(false);
  const [isColumnModalVisible, setIsColumnModalVisible] = useState(false);
  const [isModalAttachFilesVisible, setIsModalAttachFilesVisible] = useState(false);
  const [isModalLocationOnMapVisible, setIsModalLocationOnMapVisible] = useState(false);
  const [actionType, setActionType] = useState();

  // Options
  const [trainingCenterOptions, setTrainingCenterOptions] = useState([]);
  const [invoiceIssuersOptions, setInvoiceIssuersOptions] = useState([]);
  const [trainingOptions, setTrainingOptions] = useState([]);
  const [stageOptions, setStageOptions] = useState([]);
  const [bitrixUserOptions, setBitrixUserOptions] = useState([]);
  const [reasonOptions, setReasonOptions] = useState([]);
  const [instructorOptions, setInstructorOptions] = useState([]);
  const [driverOptions, setDriverOptions] = useState([]);
  const [transportCompanyOptions, setTransportCompanyOptions] = useState([]);
  const [vehicleOptions, setVehicleOptions] = useState([]);
  const [dealClientColumnOptions, setDealClientColumnOptions] = useState([]);
  const [dealClientCnpjColumnOptions, setDealClientCnpjColumnOptions] = useState([]);
  const [isModalExportTask, setIsModalExportTask] = useState(false);
  const [isModalExportEmailVisible, setIsModalExportEmailVisible] = useState(false);
  const [exportEmailLoading, setExportEmailLoading] = useState(false);
  const [exportEmail, setExportEmail] = useState('');

  // Edit
  const [editingIds, setEditingIds] = useState([]);

  // SignalR
  const hubConnection = useSignalR('tasks');

  // Filtros
  const [taskListTableFilter, setTaskListTableFilter] = useState();

  const cooldownSeconds = useReportCooldown('taskList');

  const todayDate = moment().add(-3, 'hour');
  const { canImportTasks, canHandleAnyStage } = JSON.parse(
    localStorage.getItem('conecta__userData')
  );

  useEffect(() => {
    taskListRef.current = taskList;
  }, [taskList]);

  useEffect(() => {
    if (hubConnection) {
      hubConnection.on('ReceiveTaskUpdate', (updatedTask) => {
        setTaskList((currentTasks) => {
          const notSelectableStages = [
            1, // 1 = Aguardando
            5, // 5 = Concluido
            6, // 6 = Reagendar
            11, // 11 = Distrato
          ];

          return currentTasks.map((task) => {
            if (task.id === updatedTask.id) {
              return {
                ...task,
                ...updatedTask,
                key: updatedTask.id,
                name: mountProductName(updatedTask.product),
                selectable: !notSelectableStages.includes(updatedTask.stage?.id),
              };
            }
            return task;
          });
        });
      });
    }

    return () => {
      if (hubConnection) {
        hubConnection.off('ReceiveTaskUpdate');
      }
    };
  }, [hubConnection]);

  const handleTaskListExport = async () => {
    if (editingIds.length > 0) {
      message.warn('Oops. Você não pode realizar esta ação durante a edição!');
      return;
    }
    // Pega o e-mail do usuário do localStorage
    const userData = JSON.parse(localStorage.getItem('conecta__userData') || '{}');
    setExportEmail(userData.email || '');
    setIsModalExportEmailVisible(true);
  };

  const handleConfirmExportEmail = async (email) => {
    setExportEmailLoading(true);
    const tableColumns = TaskListColumns({
      editingIds,
      fieldsPermissions,
      columnsSettings,
      instructorOptions,
      driverOptions,
      vehicleOptions,
      reasonOptions,
      transportCompanyOptions,
      invoiceIssuersOptions,
      fieldLayout,
      roleId: readLoggedRoleId(),
    });
    const columnList = tableColumns.map(({ title, dataIndex }) => ({
      label: title,
      name: dataIndex,
    }));
    const taskListExportData = { Filters: filters, columnList };
    await exportTaskListReportByEmail(taskListExportData, email);
    setIsModalExportEmailVisible(false);
    setExportEmailLoading(false);
  };

  const handleSubmit = async () => {
    try {
      const editedRowsData = mapEditedRows(formTaskList, taskList, editingIds);
      const submitData = await mapSubmitData(
        editedRowsData,
        invoiceIssuersOptions,
        instructorOptions,
        driverOptions,
        transportCompanyOptions,
        vehicleOptions,
        reasonOptions,
        stageOptions
      );

      setIsLoading(true);
      for (let index = 0; index < submitData.length; index += 1) {
        const newTask = submitData[index];
        const oldTask = JSON.parse(JSON.stringify(taskList.find(({ id }) => id === newTask.id)));

        await updateTask(newTask, oldTask, driverOptions);
      }

      message.success('Atualização dos Treinamentos concluída!');
      window.location.reload(); // Recarrega a página
    } catch (error) {
      Utils.logError(error);
      message.error('Oops. Algo deu errado ao tentar atualizar os Treinamentos selecionados!');
      setIsLoading(false);
    }
  };

  const readOpenFieldSource = (record) =>
    taskListRef.current.some((task) => task.id === record.id) ? taskListRef.current : taskList;

  const applyOpenFieldCommit = async (record, patch, uploadEvent) => {
    const latest = readOpenFieldSource(record).find((task) => task.id === record.id) || record;
    const oldTask = JSON.parse(JSON.stringify(latest));
    const nextPatch = {};

    if (Object.prototype.hasOwnProperty.call(patch, 'reasonNoBilling')) {
      nextPatch.reasonNoBilling = patch.reasonNoBilling;
    }

    if (patch.nfTrainingAppend || patch.nfTrainingRemoveName) {
      const files = [...(latest.nfTraining || [])];
      (patch.nfTrainingAppend || []).forEach((file) => {
        if (file?.name && !files.some((item) => item.name === file.name)) {
          files.push(file);
        }
      });
      nextPatch.nfTraining = patch.nfTrainingRemoveName
        ? files.filter((file) => file.name !== patch.nfTrainingRemoveName)
        : files;
    }

    const saved = await updateTrainingListOpenFields(record.id, nextPatch);
    if (!saved) return false;

    const currentSource = readOpenFieldSource(record);
    const current = currentSource.find((task) => task.id === record.id) || latest;
    const merged = { ...current, ...nextPatch };
    taskListRef.current = currentSource.map((task) => (task.id === record.id ? merged : task));
    setTaskList(taskListRef.current);

    if (uploadEvent) {
      await TaskCommentFunctions.addTaskCommentUploadFile(merged, uploadEvent, 'TaskList');
    }

    await TaskCommentFunctions.addTaskCommentHistory(merged, oldTask, 'SchedulingList');
    return true;
  };

  const commitOpenField = (record, patch, uploadEvent) => {
    const run = openFieldQueueRef.current.then(() =>
      applyOpenFieldCommit(record, patch, uploadEvent)
    );
    openFieldQueueRef.current = run.catch(() => false);
    return run;
  };

  const handleLocationConfirm = async (addressData, updateAddress) => {
    try {
      setIsLoading(true);
      for (let index = 0; index < selectedRowKeys.length; index += 1) {
        const taskId = selectedRowKeys[index];
        const oldTask = taskList.find(({ id }) => id === taskId);
        if (oldTask) {
          const newTask = { ...oldTask };
          newTask.latitude = addressData.coordinates.latitude;
          newTask.longitude = addressData.coordinates.longitude;

          if (updateAddress) {
            newTask.postalCodeLogistic = addressData.postalCodeLogistic;
            newTask.streetLogistic = addressData.streetLogistic;
            newTask.numberLogistic = addressData.numberLogistic;
            newTask.districtLogistic = addressData.districtLogistic;
            newTask.cityLogistic = addressData.cityLogistic;
            newTask.stateLogistic = addressData.stateLogistic;
          }

          await updateTask(newTask, oldTask, driverOptions);
        }
      }
      message.success('Localização atualizada com sucesso para os treinamentos selecionados!');
      window.location.reload();
    } catch (error) {
      Utils.logError(error);
      message.error('Oops. Algo deu errado ao tentar atualizar a localização dos treinamentos.');
      setIsLoading(false);
    }
  };

  const handleFetchTasks = async (pFilters = filters) => {
    if (editingIds.length > 0) {
      message.warn('Oops. Você não pode realizar esta ação durante a edição!');
      return;
    }

    setSelectedRowKeys([]);
    setEditingIds([]);
    setfilters(pFilters);
    const taskFilters = pFilters;

    if (pFilters?.period) {
      const [start, end] = pFilters.period;
      taskFilters.startDate = start;
      taskFilters.endDate = end;
    }

    const tasks = await fetchTasks({
      ...taskFilters,
      dealClient: undefined,
      dealClientCNPJ: undefined,
    });

    setDealClientColumnOptions(buildDealClientColumnOptions(tasks));
    setDealClientCnpjColumnOptions(buildDealClientCnpjColumnOptions(tasks));
    setTaskList(applyDedicatedTaskListFilters(tasks, taskFilters));
  };

  const fetchData = async () => {
    try {
      setIsLoading(true);

      const [
        instructors,
        drivers,
        transportCompanies,
        vehicles,
        settings,
        trainingCenters,
        invoiceIssuers,
        reasons,
        trainings,
        stages,
        colSettings,
        resTaskListTableFilter,
      ] = await Promise.all([
        fetchInstructors(),
        fetchDrivers(),
        fetchTransportCompanies(),
        fetchVehicles(),
        fetchSettings(),
        fetchTrainingCenters(),
        fetchInvoiceIssuers(),
        fetchReasons(),
        fetchTrainings(),
        fetchStages(),
        fetchTaskColumnsSettings(),
        fetchTaskListTableFilter(),
      ]);

      setInstructorOptions(instructors);
      setDriverOptions(drivers);
      setTransportCompanyOptions(transportCompanies);
      setVehicleOptions(vehicles);
      setTrainingCenterOptions(trainingCenters);
      setInvoiceIssuersOptions(invoiceIssuers);
      setReasonOptions(reasons);
      setTrainingOptions(trainings);
      setStageOptions(stages);
      setColumnsSettings(colSettings);
      setTaskListTableFilter(resTaskListTableFilter);

      await UserFunctions.fetchBitrixUsers(settings.bitrixWebhookUrl, setBitrixUserOptions);
      setSettings(settings);

      await handleFetchTasks(resTaskListTableFilter?.filters || { period: [todayDate, todayDate] });
    } catch (error) {
      Utils.logError(error);
      message.error('Oops. Algo deu errado ao tentar buscar as opções de filtro!');
    } finally {
      setIsLoading(false);
    }
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: (newSelectedRowKeys) => {
      setSelectedRowKeys(newSelectedRowKeys);
    },
    getCheckboxProps: (record) => ({
      disabled: (editingIds.length > 0 || record.selectable === false) && !canHandleAnyStage,
      style: record.hideCheckbox ? { display: 'none' } : {},
    }),
  };

  const handleActionUpdate = async (type) => {
    try {
      setIsLoading(true);
      const userData = JSON.parse(localStorage.getItem('conecta__userData'));
      let btnAction = null;
      let otherDataChange = null;

      switch (type) {
        case 'confirm':
          btnAction = 'Confirmar';
          otherDataChange = {
            confirmedBy: userData.name,
            idConfirmedBy: parseInt(userData.id, 10),
            confirmationDate: moment().format('YYYY-MM-DDTHH:mm:ss'),
          };
          break;
        case 'deny':
          btnAction = 'Negar';
          break;
        case 'noClientContact':
          btnAction = 'SemContatoCliente';
          break;
        default:
          break;
      }

      for (let index = 0; index < selectedRowKeys.length; index += 1) {
        let data = taskList.find(({ id }) => id === selectedRowKeys[index]);
        const oldTaskData = JSON.parse(JSON.stringify(data));

        // Atualiza o objeto antes de enviar
        data = { ...data, ...otherDataChange };

        // Enviar para atualizar com o parâmetro btnAction apropriado
        const apiUrl = btnAction
          ? `/Task/UpdateTaskScheduling?btnAction=${btnAction}`
          : '/Task/UpdateTaskScheduling';
        await api.put(apiUrl, data);

        // Eventos secundárias
        await TaskCommentFunctions.addTaskCommentActivities(data, oldTaskData, 'SchedulingList');
        await TaskCommentFunctions.addTaskCommentHistory(data, oldTaskData, 'SchedulingList');
      }

      message.success('Atualização dos Treinamentos concluída!');
      window.location.reload(); // Recarrega a página
    } catch (error) {
      Utils.logError(error);
      message.error('Oops. Algo deu errado ao tentar atualizar os Treinamentos selecionados!');
      setIsLoading(false);
    }
  };

  const handleActionClick = (type) => {
    if (['confirm', 'deny', 'noClientContact'].includes(type)) {
      setActionType(type);
      setIsModalConfirmationVisible(true);
    } else {
      Utils.error('Tipo de ação inválido:', type);
    }
  };

  const handleFilterSave = async () => {
    setIsFilterLoading(true);
    const filterFormValues = formFilter.getFieldsValue();
    const submitData = {};
    submitData.filters = filterFormValues;

    if (taskListTableFilter) {
      submitData.id = taskListTableFilter.id;

      await updateTaskListTableFilter(submitData);
    } else {
      await addTaskListTableFilter(submitData);
      setTaskListTableFilter(await fetchTaskListTableFilter());
    }
    setIsFilterLoading(false);
  };

  const handleFilterSubmit = async (pFilters) => {
    setIsLoading(true);
    await handleFetchTasks(pFilters);
    setIsLoading(false);
  };

  const renderFilter = () => (
    <Form
      form={formFilter}
      disabled={isLoading || isFilterLoading}
      name="TaskListFilter"
      onFinish={handleFilterSubmit}
      layout="vertical"
      autoComplete="off"
      initialValues={
        taskListTableFilter?.filters || {
          period: [todayDate, todayDate],
          responsibles: [],
          stages: [],
          trainingCenterIds: [],
          dealClient: '',
          dealId: '',
          dealClientCNPJ: '',
          trainings: [],
          typeTrainings: [],
        }
      }
      style={{ width: '25vw', backgroundColor: 'white', padding: '16px', borderRadius: '8px' }}
    >
      <Form.Item name="period" label="Período">
        <RangePicker format="DD/MM/YYYY" />
      </Form.Item>
      <Form.Item label="Centro de Treinamento" name="trainingCenterIds">
        <Select
          options={trainingCenterOptions}
          placeholder="Selecione um CT"
          optionFilterProp="label"
          dropdownStyle={{ borderRadius: 16, zIndex: 1050 }}
          showSearch
          allowClear
          removeIcon={false}
          mode="multiple"
          maxTagCount={1}
          onChange={(values) =>
            Utils.handleSelectAllChange(
              values,
              trainingCenterOptions,
              'trainingCenterIds',
              formFilter
            )
          }
        />
      </Form.Item>
      <Form.Item label="Nome da empresa" name="dealClient">
        <AutoComplete
          allowClear
          options={dealClientColumnOptions}
          placeholder="Nome do Cliente"
          filterOption={(inputValue, option) =>
            String(option?.value || '')
              .toLowerCase()
              .includes(String(inputValue || '').toLowerCase())
          }
        />
      </Form.Item>
      <Form.Item label="ID do negócio" name="dealId">
        <Input allowClear />
      </Form.Item>
      <Form.Item label="CNPJ" name="dealClientCNPJ">
        <AutoComplete
          allowClear
          options={dealClientCnpjColumnOptions}
          placeholder="CNPJ Cliente"
          filterOption={(inputValue, option) => {
            const typed = String(inputValue || '').replace(/\D/g, '');
            const optionDigits = String(option?.value || '').replace(/\D/g, '');
            if (typed) return optionDigits.includes(typed);
            return String(option?.value || '')
              .toLowerCase()
              .includes(String(inputValue || '').toLowerCase());
          }}
        />
      </Form.Item>
      <Form.Item label="Responsável" name="responsibles">
        <Select
          options={bitrixUserOptions}
          allowClear
          placeholder="Selecione"
          optionFilterProp="label"
          showSearch
          dropdownStyle={{ borderRadius: 16, zIndex: 1050 }}
          removeIcon={false}
          mode="multiple"
          maxTagCount={1}
          onChange={(values) =>
            Utils.handleSelectAllChange(values, bitrixUserOptions, 'responsibles', formFilter)
          }
        />
      </Form.Item>
      <Form.Item label="Estágio" name="stages">
        <Select
          options={stageOptions}
          allowClear
          placeholder="Selecione"
          optionFilterProp="label"
          showSearch
          dropdownStyle={{ borderRadius: 16, zIndex: 1050 }}
          removeIcon={false}
          mode="multiple"
          maxTagCount={1}
          onChange={(values) =>
            Utils.handleSelectAllChange(values, stageOptions, 'stages', formFilter)
          }
        />
      </Form.Item>
      <Form.Item label="Treinamento" name="trainings">
        <Select
          options={trainingOptions}
          allowClear
          placeholder="Selecione"
          optionFilterProp="label"
          showSearch
          dropdownStyle={{ borderRadius: 16 }}
          removeIcon={false}
          mode="multiple"
          maxTagCount={1}
          onChange={(values) =>
            Utils.handleSelectAllChange(values, trainingOptions, 'trainings', formFilter)
          }
        />
      </Form.Item>
      <Form.Item label="Tipo" name="typeTrainings">
        <Select
          options={[
            { label: 'CT', value: 'CT' },
            { label: 'In Company', value: 'In Company' },
            { label: 'EAD', value: 'EAD' },
          ]}
          optionFilterProp="label"
          dropdownStyle={{ borderRadius: 16 }}
          mode="multiple"
          maxTagCount={3}
        />
      </Form.Item>
      <Row gutter={[12]}>
        <Col span={8}>
          <Button
            type="primary"
            htmlType="submit"
            icon={<SearchOutlined />}
            style={{ width: '100%' }}
          >
            Buscar
          </Button>
        </Col>
        <Col span={8}>
          <Button type="default" onClick={handleFilterSave} style={{ width: '100%' }}>
            Salvar
          </Button>
        </Col>
        <Col span={8}>
          <Button
            type="default"
            onClick={() =>
              formFilter.setFieldsValue({
                period: [],
                responsibles: [],
                stages: [],
                trainingCenterIds: [],
                dealClient: '',
                dealId: '',
                dealClientCNPJ: '',
                trainings: [],
                typeTrainings: [],
              })
            }
            style={{ width: '100%' }}
          >
            Limpar
          </Button>
        </Col>
      </Row>
    </Form>
  );

  const tableComponents = {
    body: {
      row: (props) => (
        <EditableRowWrapper
          {...props}
          form={formTaskList}
          record={taskList.find((task) => task.id === props['data-row-key'])}
          editingIds={editingIds}
          taskList={taskList}
        />
      ),
      cell: EditableCellComponent,
    },
  };

  useEffect(() => {
    fetchData();

    const permissions = {};
    JSON.parse(localStorage.getItem('conecta__permissions'))?.resources.forEach(
      ({ name, fields }) => {
        if (name === 'TrainingList') {
          fields.forEach(({ name, access, isRequired, isADM }) => {
            permissions[name] = { access, isRequired, isADM };
          });
        }
      }
    );

    setFieldsPermissions(permissions);

    const portalResource = readPortalResource('TrainingList');
    loadAgendaFieldLayout(portalResource.resourceId).then(setFieldLayout);
  }, []);

  if (isLoading || !fieldsPermissions) {
    return (
      <Row gutter={[24]}>
        <Col
          span={24}
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '72vh',
          }}
        >
          <Spin
            indicator={
              <LoadingOutlined
                style={{
                  fontSize: 56,
                  textAlign: 'center',
                }}
                spin
              />
            }
          />
        </Col>
      </Row>
    );
  }

  if (!isLoading && fieldsPermissions) {
    return (
      <>
        <div style={{ marginBottom: '16px', display: 'flex', justifyContent: 'space-between' }}>
          <div style={{ display: 'flex', gap: '8px' }}>
            <Tooltip title="Personalizar exibição de colunas">
              <Button
                onClick={() => {
                  if (editingIds.length > 0) {
                    message.warn('Oops. Você não pode realizar esta ação durante a edição!');
                    return;
                  }

                  setIsColumnModalVisible(true);
                }}
                icon={<SettingOutlined />}
                disabled={editingIds.length > 0}
              />
            </Tooltip>

            {fieldsPermissions?.ExportBtn?.access >= 1 && (
              <Tooltip
                title={
                  cooldownSeconds > 0
                    ? `Aguarde ${cooldownSeconds}s`
                    : 'Exportar Lista de Treinamentos'
                }
              >
                <Button
                  onClick={handleTaskListExport}
                  icon={<FileExcelOutlined />}
                  disabled={editingIds.length > 0 || cooldownSeconds > 0}
                />
              </Tooltip>
            )}

            {canImportTasks && (
              <Tooltip title="Importar Treinamentos p/ Planilha">
                <Button
                  onClick={() => {
                    if (selectedRowKeys.length > 0) {
                      setIsModalExportTask(true);
                    }
                  }}
                  icon={<UploadOutlined />}
                  disabled={editingIds.length > 0 || selectedRowKeys.length === 0}
                />
              </Tooltip>
            )}

            <Tooltip title="Filtros">
              {editingIds.length === 0 ? (
                <Popover content={renderFilter} trigger="click" overlayClassName="custom-popover">
                  <Button type="default" className="filterComponent" icon={<FilterOutlined />} />
                </Popover>
              ) : (
                <Button
                  type="default"
                  className="filterComponent"
                  icon={<FilterOutlined />}
                  disabled={editingIds.length > 0}
                />
              )}
            </Tooltip>
          </div>

          <ActionButtonsComponent
            selectedRowKeys={selectedRowKeys}
            taskList={taskList}
            editingIds={editingIds}
            fieldsPermissions={fieldsPermissions}
            handleActionClick={handleActionClick}
            setIsModalDeletingVisible={setIsModalDeletingVisible}
            setIsModalAttachFilesVisible={setIsModalAttachFilesVisible}
            setEditingIds={setEditingIds}
            handleSubmit={handleSubmit}
            formTaskList={formTaskList}
            setIsModalLocationOnMapVisible={setIsModalLocationOnMapVisible}
          />
        </div>

        <Form
          form={formTaskList}
          disabled={isLoading}
          name="TaskListForm"
          layout="vertical"
          autoComplete="off"
          component={false}
        >
          <Form.List name="list">
            {() => (
              <Table
                rowKey="id"
                columns={TaskListColumns({
                  editingIds,
                  fieldsPermissions,
                  columnsSettings,
                  instructorOptions,
                  driverOptions,
                  vehicleOptions,
                  reasonOptions,
                  transportCompanyOptions,
                  formTaskList,
                  invoiceIssuersOptions,
                  fieldLayout,
                  roleId: readLoggedRoleId(),
                  onCommitOpenField: commitOpenField,
                })}
                components={tableComponents}
                rowSelection={rowSelection}
                dataSource={taskList}
                scroll={{ y: '75vh' }}
                size="small"
                pagination={{
                  position: ['bottomRight'],
                  size: 'default',
                  defaultPageSize: 10,
                  pageSizeOptions: [10, 20, 30, 50, 100, 200, 500, 1000, 5000, 10000],
                  showSizeChanger: true,
                  total: taskList?.length ?? 0,
                  showTotal: (total) => `${total} treinamentos`,
                }}
                className="task-list-table"
              />
            )}
          </Form.List>
        </Form>

        {isModalDeletingVisible && (
          <DeletingModal
            taskList={taskList}
            setLoading={setIsLoading}
            setIsVisible={setIsModalDeletingVisible}
            reasonsOptions={reasonOptions}
            selectedRowKeys={selectedRowKeys}
          />
        )}

        {isModalConfirmationVisible && (
          <ConfirmationModal
            setIsVisible={setIsModalConfirmationVisible}
            onConfirm={handleActionUpdate}
            actionType={actionType}
            taskList={taskList}
            selectedRowKeys={selectedRowKeys}
          />
        )}

        {isColumnModalVisible && (
          <ColumnsSettingsModal
            columns={(columnArgs) =>
              TaskListColumns({
                ...columnArgs,
                fieldLayout,
                roleId: readLoggedRoleId(),
              })
            }
            setIsVisible={setIsColumnModalVisible}
            columnsSettings={columnsSettings}
            fieldsPermissions={fieldsPermissions}
          />
        )}

        {isModalAttachFilesVisible && (
          <AttachFilesModal
            setIsVisible={setIsModalAttachFilesVisible}
            taskList={taskList}
            selectedRowKeys={selectedRowKeys}
            driverOptions={driverOptions}
            stageOptions={stageOptions}
          />
        )}

        {isModalExportTask && (
          <ModalUploadExcel
            setIsOpen={setIsModalExportTask}
            isOpen={isModalExportTask}
            screenType="taskList"
            taskIds={selectedRowKeys}
          />
        )}

        {isModalLocationOnMapVisible && (
          <LocationOnMapModal
            isOpen={isModalLocationOnMapVisible}
            setIsOpen={setIsModalLocationOnMapVisible}
            onConfirm={handleLocationConfirm}
            settings={settings}
          />
        )}

        <ExportTaskListEmailModal
          isVisible={isModalExportEmailVisible}
          setIsVisible={setIsModalExportEmailVisible}
          onConfirm={handleConfirmExportEmail}
          defaultEmail={exportEmail}
          loading={exportEmailLoading}
          canEditEmail={fieldsPermissions?.ExportBtn?.access === 2}
        />
      </>
    );
  }
}
